import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_upjbcsvbjr: FaireBrandEntity = {
  token: "b_upjbcsvbjr",
  type: "brand",
  name: "David Protein",
  avatarUrl:
    "https://cdn.faire.com/fastly/178662ff000858b78478f15f276e92e2fe58e33f35e2cb88cb5de9b862d34d89.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/29ee4f01299d0d0fbc45ec3e4c9c858ee0e1729cd7c5ca0b7545c7e5682d0ad9.png",
  logoUrl:
    "https://cdn.faire.com/fastly/178662ff000858b78478f15f276e92e2fe58e33f35e2cb88cb5de9b862d34d89.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/29ee4f01299d0d0fbc45ec3e4c9c858ee0e1729cd7c5ca0b7545c7e5682d0ad9.png",
  location: "New York City, NY, USA",
  minimumOrderDollars: 149,
  rating: 4.6,
  reviewCount: 12,
  isInsider: true,
  description:
    "We created David because we believed that exceptionalism in the protein bar category was possible. We envisioned a protein bar that could serve as the ultimate tool for building muscle and reducing fat - providing essential nutrients while delivering an unmatched sense of satiation.\n\nOur Gold bars contain 28g of protein, 150 calories, and 0g of sugar - the highest calories from protein ratio on the market. Our Bronze bars offer 20g of protein at 150 calories with a more indulgent, dessert-like taste.\n\nWe value our wholesale partners and strive to offer the best experience in the industry. Please message us on Faire or email us at [redacted-email] if there's anything we can do for you!",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:46.935Z",
    importedBy: "entity-db-cli",
  },
};
